import LanguageDetector from "i18next-browser-languagedetector";
import commonEN from "./strings/en-US/common";
import enumsEN from "./strings/en-US/enums";
import tenantSettingsEN from "./strings/en-US/tenantSettings";
import permitTypesEN from "./strings/en-US/permitTypes";
import permitsEN from "./strings/en-US/permits";
import jobsEN from "./strings/en-US/jobs";
import toastsEN from "./strings/en-US/toasts";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import entitiesEN from "./strings/en-US/entities";
import userSettingsEN from "./strings/en-US/userSettings";
import commandCenterEN from "./strings/en-US/commandCenter";
import rulesEN from "./strings/en-US/rules";
import propertiesEN from "./strings/en-US/properties";
import permissionsEN from "./strings/en-US/permissions";
import qrCodesEN from "./strings/en-US/qrCodes";
import reportsEN from "./strings/en-US/reports";
import activityFeedEN from "./strings/en-US/activityFeed";
import importWizardEN from "./strings/en-US/importWizard";
i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    lng: "en",
    fallbackLng: "en",
    // debug: true,
    defaultNS: "common",
    returnObjects: true,
    interpolation: {
      skipOnVariables: false,
    },
    resources: {
      en: {
        common: commonEN,
        enums: enumsEN,
        tenantSettings: tenantSettingsEN,
        permitTypes: permitTypesEN,
        permits: permitsEN,
        jobs: jobsEN,
        toasts: toastsEN,
        entities: entitiesEN,
        userSettings: userSettingsEN,
        commandCenter: commandCenterEN,
        rules: rulesEN,
        properties: propertiesEN,
        permissions: permissionsEN,
        qrCodes: qrCodesEN,
        reports: reportsEN,
        activityFeed: activityFeedEN,
        importWizard: importWizardEN,
      },
    },
  });
